module.exports = __webpack_public_path__ + "zvetseni-prsou_66_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_66_after.jpg
// module id = 1359
// module chunks = 0